import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
  },
  stepper: {
    background: 'transparent',
    padding: '24px 0',
  },
  stepContainer: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(4),
  },
  divider: {
    margin: '40px 0 24px 0',
    height: '1px',
    backgroundColor: theme.palette.divider,
  },
  navigationContainer: {
    padding: '8px 4px',
  },
  carregando: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: 40,
  },
}))
